import { Collapse, Icon, Progress } from 'antd';
import React from 'react';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import * as Util from '../../util';
import LaneContainer from '../UI/LaneContainer';
import Review from './Review';
import { connectToTitle } from '../Title/containers/TitleDataStore';
import { connectToCommunities } from '../Communities/containers/communitiesDataStore';
import combineConnectors from '../util/combineConnectors';
import { connectToUser } from '../User/containers/UserDataStore';

const Panel = Collapse.Panel;

export class ReviewsByRating extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			visible: false,
			dataRetrieved: false,
			reviews: [],
		};
	}

	renderReviews = reviews => {
		return reviews.map((review, idx) => {
			return <Review review={review} source="title" key={`rev-${idx}`} />;
		});
	};

	getReviewExpandables = reviews => {
		const reviewsByRating = Util.groupBy(reviews, 'rating');
		const { isAnonymous } = this.props.userDataStore;
		return Object.keys(reviewsByRating)
			.reverse()
			.map(rating => (
				<Panel
					disabled={isAnonymous()}
					header={this.getReviewHeader(
						rating,
						Object.keys(reviewsByRating[rating]).length,
						reviews.length,
					)}
					key={rating}>
					{this.renderReviews(
						reviews.filter(rev => rev.rating == rating),
					)}
				</Panel>
			));
	};

	getReviewHeader = (rating, reviews, totalReviews) => {
		return (
			<React.Fragment>
				<span>
					{reviews} rated <span className="bold">{rating} of 10</span>
				</span>
				<Progress
					percent={parseInt(
						((reviews / totalReviews) * 100).toFixed(0),
					)}
				/>
			</React.Fragment>
		);
	};

	render() {
		const { communityId } = this.props;
		const { areReviewsLoading, reviews } = this.props.titleDataStore.state;
		if (!areReviewsLoading) {
			if (reviews && reviews.length > 0) {
				const averageRating =
					reviews.reduce((a, b) => a + (b['rating'] || 0), 0) /
					reviews.length;
				return (
					<LaneContainer
						majorHeader={this.getHeader(reviews, averageRating)}>
						<Collapse
							style={{
								marginRight: '20px',
								marginBottom: '15px',
							}}
							expandIcon={({ isActive }) => (
								<Icon
									type="caret-right"
									rotate={isActive ? 90 : 0}
								/>
							)}>
							{this.getReviewExpandables(reviews)}
						</Collapse>
					</LaneContainer>
				);
			} else {
				if (communityId === 0) {
					return <LaneContainer majorHeader="No Community Reviews" />;
				}

				const { communities } = this.props.communitiesDataStore.state;
				const community = communities.filter(
					c => !c.id === communityId,
				);
				return (
					<LaneContainer
						majorHeader={
							<div>
								<span>No </span>
								{community &&
									community.length > 0 &&
									community[0].name}
								<span>Community Reviews</span>
							</div>
						}
					/>
				);
			}
		} else {
			return (
				<LaneContainer
					majorHeader={
						<span style={{ fontStyle: 'italic', color: '#d2d6d8' }}>
							Loading Community Reviews...
						</span>
					}
				/>
			);
		}
	}

	getHeader = (reviews, averageRating) => {
		const isMobile = this.props.isMobile();
		return !isMobile ? (
			<span>
				{reviews.length} Community Reviews - {averageRating.toFixed(1)}{' '}
				average rating
			</span>
		) : (
			<span>
				{reviews.length} Community Reviews
				<br />
				<span style={{ fontSize: '15px', fontWeight: 'normal' }}>
					{averageRating.toFixed(1)} average rating
				</span>
			</span>
		);
	};
}

const connectors = [
	connectToTitle,
	withIsMobile,
	connectToCommunities,
	connectToUser,
];

export default combineConnectors(connectors)(ReviewsByRating);
